import { AsyncAction } from '../../base-classes';
import { ComplianceInfoProvider } from '../providers/complianceInfoProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_COMPLIANCE_INFO = new AsyncAction('GET_COMPLIANCE_INFO');

export function getComplianceInfo(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        options: undefined,
        logger: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        LocationType: undefined,
        Location: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_COMPLIANCE_INFO.base,
        payload: getComplianceInfoAction(paramsObject)
    };
}

async function getComplianceInfoAction({ baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh, LocationType, Location }) {
    const op = new ComplianceInfoProvider(baseUrl, authId, secret, options, logger);
    const results = await op.getComplianceInfo(stdParameters, verbose, refresh, LocationType, Location);
    return results;
}
